/* External Dependencies */
import { Component, OnInit } from '@angular/core';
import { FormGroup,FormControl } from '@angular/forms';
import { Router } from '@angular/router';

/* Internal Dependencies */
import { AuthService } from '../auth.service';
import { MessageDialogService } from './../../service/message-dialog.service';

export interface authen {
  gid:number;
  token:string;
  uid:number;
  valid:boolean;
};
export interface key {
  bsid: string;
  pk: number[];
};

declare var RSAKey: any;


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {


  constructor(
    public authService: AuthService, 
    public router: Router, 
    private msgDialog: MessageDialogService
    ) {
  }

  rsa = new RSAKey();
  key:any = {};
  passpharse;
  userNotFound:boolean = false;

  msg:string;
  invalid:boolean = false;
  loginForm = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
    remember: new FormControl(false)
  });

  ngOnInit(): void {
    
  }


  login() {
    let username = this.loginForm.value.username;
    let password = this.loginForm.value.password;
    let remember = this.loginForm.value.remember;

    if(username === '' && password ===''){
      this.invalid = true;
      this.msg = this.msgDialog.msgInputText('Username or Password are not correct.');
    }else if(username === ''){
      this.invalid = true;
      this.msg = this.msgDialog.msgInputText('Username are not correct.');
    }else if(password === ''){
      this.invalid = true;
      this.msg = this.msgDialog.msgInputText('Password are not correct.');
    } else {
      this.invalid = false;
      this.setKey(username,password,remember);
    }
  }

  setKey(username:string,password:string,remember:boolean){
    let passpharse = JSON.stringify({username: username, password: password, remember: remember});
    this.authen(username,password,passpharse);
  }

  authen(username:string,password:string,passpharse) {
    this.authService.loginServ(passpharse).subscribe(
      (authen)=>{
        if(authen.valid){
          this.authService.authorize(username,authen.uid,authen.gid,authen.token);
        }
      }, (err) => {
        // console.log("authen:",err);
        this.invalid = false;
        this.msg = this.msgDialog.msgInputText('username or password incorrect');
      }
    );
  }
  
}
